import last from 'lodash/last';

import { TOOLTIP_NOISE } from '~src/constants';

const noiseLevelToDescription: [number, string][] = [
  [70, 'støjen fra en håndmixer'],
  [68, 'støjen fra en personbil, der kører 80 km/t'],
  [65, 'lyden af en emhætte'],
  [62, 'lyden af normal tale'],
  [60, 'vindstøjen fra træer'],
  [56, 'lyden fra en vaskemaskine'],
  [53, 'lyden i et bibliotek'],
  [50, 'lyden af et stille hjem'],
  [48, 'mindre end lyden af et stille hjem'],
];

const findDescriptionForNoiseLevel = (noiseLevel: number): string => {
  if (noiseLevel <= 48) {
    return last(noiseLevelToDescription)?.[1] ?? '';
  }

  if (noiseLevel >= 70) {
    return noiseLevelToDescription[0]?.[1] ?? '';
  }

  return noiseLevelToDescription.find(([level]) => noiseLevel >= level)?.[1] ?? '';
};

export const getTooltipForNoiseLevel = (noiseLevel: number): string => {
  const description = findDescriptionForNoiseLevel(noiseLevel);

  return `${TOOLTIP_NOISE}${description}.`;
};
